var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{staticStyle:{"z-index":"9999"},attrs:{"value":_vm.isActive}},[_c('v-card',{attrs:{"height":"120","width":"120","align":"center","justify":"center"}},[_c('v-card-text',{staticClass:"pt-8"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"56"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }